/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditConversationsEditNewScorecardAttributeNewValueRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.edit.conversations.edit.new-scorecard.attribute-new.value',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditConversationsEditNewScorecardAttributeNewValueRoute);
